/**
 * Centralized logging utility
 */

export const logger = {
  error: (message: string, error?: Error, context?: Record<string, unknown>) => {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.error(message, error, context);
    }
  },

  warn: (message: string, context?: Record<string, unknown>) => {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.warn(message, context);
    }
  },

  info: (message: string, context?: Record<string, unknown>) => {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.info(message, context);
    }
  },
};
